import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import OpportunityReport from "@/components/OpportunityReport";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Eye } from "lucide-react";

export default function PacketPreview() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  useEffect(() => { api.get(`/packets/${id}/report`).then(r => setData(r.data)); }, [id]);
  if (!data) return <div className="min-h-screen flex items-center justify-center text-sm text-slate-500">Loading preview…</div>;
  return (
    <div>
      <div className="bg-slate-900 text-white sticky top-0 z-40 no-print">
        <div className="max-w-5xl mx-auto px-6 py-2.5 flex items-center justify-between text-xs">
          <div className="flex items-center gap-2">
            <Eye className="w-3.5 h-3.5" />
            <span className="font-semibold uppercase tracking-widest text-[10px]">Internal preview — this is exactly what the shareholder will see</span>
          </div>
          <Link to={`/packets/${id}`} className="inline-flex items-center gap-1 hover:text-[#C25E00]" data-testid="preview-back-link">
            <ArrowLeft className="w-3.5 h-3.5" /> Back to workspace
          </Link>
        </div>
      </div>
      <OpportunityReport data={data} mode="internal-preview" />
    </div>
  );
}
